/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable import/no-anonymous-default-export */

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const defaultType = dc.getType('default');
  const defaultView = defaultType.view;

  editor.on('load', () => {
    const {head} = editor.Canvas.getDocument();
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
    // script.onload = () => console.log('Particles.js loaded!');
    head.appendChild(script);

    const style = document.createElement('style');
    style.innerHTML = `
    .gjs-particles-wrapper {
      position: relative;
      width: 100%;
      height: 300px;
      overflow: hidden;
    }
    .gjs-particles-wrapper canvas {
      position: absolute !important;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
      pointer-events: none;
      z-index: 0;
    }
    .gjs-particles-wrapper > *:not(canvas) {
      position: relative;
      z-index: 1;
    }
  `;
    head.appendChild(style);
  });

  dc.addType(opts.name, {
    model: {
      defaults: {
        name: 'Particles Background',
        droppable: true,
        attributes: {
          class: 'gjs-particles-wrapper',
        },
        traits: [
          {
            type: 'number',
            name: 'particleCount',
            label: 'Numero de Particulas',
            changeProp: 1,
            min: 10,
            max: 500,
          },
          {
            type: 'color',
            name: 'particleColor',
            label: 'Color de Particulas',
            changeProp: 1,
            default: '#000000',
          },
          {
            type: 'number',
            name: 'lineLinkDistance',
            label: 'Distancia entre Particulas',
            changeProp: 1,
            min: 0,
            max: 500,
            default: 150,
          },
          {
            type: 'number',
            name: 'particleSize',
            label: 'Tamaño de Particulas',
            changeProp: 1,
            min: 1,
            max: 10,
            default: 3,
          },
          {
            type: 'select',
            name: 'shapeType',
            label: 'Figura de Particulas',
            changeProp: 1,
            options: [
              {value: 'circle', name: 'Circle'},
              {value: 'edge', name: 'Square'},
              {value: 'triangle', name: 'Triangle'},
              {value: 'polygon', name: 'Polygon'},
              {value: 'star', name: 'Star'},
            ],
            default: 'circle',
          },
        ],
        script: function nameScript() {
          const el = this;
          // if (!el.id) el.id = `particles-${Math.random().toString(36).substr(2, 9)}`;
          const count = parseInt(el.getAttribute('particleCount')) || 80;
          const color = el.getAttribute('particleColor') || '#000000';
          const shape = el.getAttribute('shapeType') || 'circle';
          const size = parseInt(el.getAttribute('particleSize')) || 3;
          const distancePart = parseInt(el.getAttribute('lineLinkDistance')) || 150;
          setTimeout(() => {
            if (window.particlesJS && el) {
              window.particlesJS(el.id, {
                particles: {
                  number: {
                    value: count,
                    density: {enable: true, value_area: 800},
                  },
                  color: {value: color},
                  shape: {
                    type: shape,
                    stroke: {width: 0, color: '#000000'},
                  },
                  opacity: {
                    value: 0.5,
                    random: false,
                    anim: {enable: false},
                  },
                  size: {
                    value: size,
                    random: true,
                    anim: {enable: false},
                  },
                  line_linked: {
                    enable: true,
                    distance: distancePart,
                    color,
                    opacity: 0.4,
                    width: 1,
                  },
                  move: {
                    enable: true,
                    speed: 6,
                    direction: 'none',
                    out_mode: 'out',
                  },
                },
                interactivity: {
                  detect_on: 'canvas',
                  events: {
                    onhover: {enable: true, mode: 'repulse'},
                    onclick: {enable: true, mode: 'push'},
                  },
                  modes: {
                    repulse: {distance: 100},
                    push: {particles_nb: 4},
                  },
                },
                retina_detect: true,
              });
            }
          }, 300);
        },
      },
    },
    // eslint-disable-next-line consistent-return
    isComponent: (el) => {
      try {
        const attr = el.attributes;
        if (attr['data-gjs-sluglofty'] && attr['data-gjs-sluglofty'].value.includes('animatedBackgroundContainer')) {
          return {
            type: opts.name,
          };
        }
      } catch (error) {
        //
      }
    },

    view: defaultView.extend({
      init({model}) {
        this.listenTo(model, 'change:particleColor', this.configureColor);
        this.listenTo(model, 'change:particleCount', this.configureCount);
        this.listenTo(model, 'change:lineLinkDistance', this.configureLinkDistance);
        this.listenTo(model, 'change:particleSize', this.configureParticleSize);
        this.listenTo(model, 'change:shapeType', this.configureShape);
        this.listenTo(model, '', this.updateState());
      },
      configureColor() {
        if (this.model.attributes.sluglofty.includes('animatedBackgroundContainer')) {
          const color = this.model.get('particleColor');
          this.model.addAttributes({
            particleColor: color,
          });
          this.render();
        }
      },
      configureCount() {
        if (this.model.attributes.sluglofty.includes('animatedBackgroundContainer')) {
          const count = this.model.get('particleCount');
          this.model.addAttributes({
            particleCount: count,
          });
          this.render();
        }
      },
      configureLinkDistance() {
        if (this.model.attributes.sluglofty.includes('animatedBackgroundContainer')) {
          const lineLink = this.model.get('lineLinkDistance');
          this.model.addAttributes({
            lineLinkDistance: lineLink,
          });
          this.render();
        }
      },
      configureParticleSize() {
        if (this.model.attributes.sluglofty.includes('animatedBackgroundContainer')) {
          const partSize = this.model.get('particleSize');
          this.model.addAttributes({
            particleSize: partSize,
          });
          this.render();
        }
      },
      configureShape() {
        if (this.model.attributes.sluglofty.includes('animatedBackgroundContainer')) {
          const shape = this.model.get('shapeType');
          this.model.addAttributes({
            shapeType: shape,
          });
          this.render();
        }
      },
      updateState() {
        if (this.model.attributes.sluglofty.includes('animatedBackgroundContainer')) {
          // const {id} = this.getAttributes();
          if (!this.attributes?.id?.includes('particles-')) {
            const newId = `particles-${Math.random().toString(36).substr(2, 9)}`;
            this.model.addAttributes({id: newId});
          }
        }
      },
    }),
  });
};
